import { t } from '@lingui/macro';

import Filter from '../../page-framework/filter/FilterDecorator';
import { filterPropDefaults } from '../../page-framework/filter/FilterPropTypes';
import DateTimeFilterStateServiceFactory from './DateTimeFilterStateService';

export const filterId = 'DateTime';
export const filterTitle = t`Time`;

function DateTimeFilter() {
    // This is a 'headless' filter that is only used on the path detail page, so
    // there's nothing to render.
    return null;
}

DateTimeFilter.defaultProps = {
    ...filterPropDefaults,
    id: filterId,
    title: filterTitle,
};

export default Filter({
    filterId,
    filterStateServiceFactory: DateTimeFilterStateServiceFactory,
})(DateTimeFilter);
